import dayjs, { Dayjs } from "dayjs"
import {
  REFUND_DOUBLE_PAYMENT_MONTHS,
  SEASONAL_FACTOR_SUMMER,
  SEASONAL_FACTOR_WINTER,
  SUMMER_MONTHS,
} from "@/constants/finance"

export function calcSeasonalPayment(
  amount: number,
  isSeasonal: boolean,
  month: number,
): number {
  if (isSeasonal) {
    if (SUMMER_MONTHS.includes(month)) {
      return amount * SEASONAL_FACTOR_SUMMER
    } else {
      return amount * SEASONAL_FACTOR_WINTER
    }
  }
  return amount
}

export function calcAveragePayment(
  amount: number,
  isSeasonal: boolean,
  month: number,
): number {
  if (isSeasonal) {
    if (SUMMER_MONTHS.includes(month)) {
      return amount / SEASONAL_FACTOR_SUMMER
    } else {
      return amount / SEASONAL_FACTOR_WINTER
    }
  }
  return amount
}

export function mustLeave2MonthCreditAfterRefund(): boolean {
  const currentMonth = dayjs().month() + 1
  return REFUND_DOUBLE_PAYMENT_MONTHS.includes(currentMonth)
}

/**
 * Calculates the first payment date based on the given payment day and minimum days in advance.
 * @param paymentDay - The day of the month for the payment.
 * @param minDaysInAdvance - The minimum number of days in advance for the payment.
 * @returns The first payment date as a Dayjs object.
 */
export function firstPaymentDate(
  paymentDay: number,
  minDaysInAdvance: number,
): Dayjs {
  const today = dayjs().startOf("day")
  const earliestPaymentDate = today.add(minDaysInAdvance, "days")

  let paymentDate = today.set("date", paymentDay)

  while (paymentDate.isBefore(earliestPaymentDate)) {
    paymentDate = paymentDate.add(1, "month")
  }

  return paymentDate
}
